import React from 'react';
import './Header_for_multistep.css';

class Header_for_multistep extends React.Component {
    render () {
        return (
            <header>
                <div className='header_container'>
                    <i  className='material-icons' 
                            onClick={this.props.handleBackButton} >arrow_back_ios</i>  
                    <h1>{this.props.text}</h1>
                    {/* Spacer matches the back arrow so the title stays centered.
                        The person icon is decorative and not a menu — hide it on
                        flows like signup where it looks like a logged-in profile. can fix this down the line by changing the header component  */}
                    <div className='background_for_icon'>
                        {this.props.hidePersonIcon ? (
                            <span className='header_person_icon_spacer' aria-hidden='true' />
                        ) : (
                            <i className='material-icons-outlined person_icon'>person</i>
                        )}
                    </div>
                </div>
            </header>
            );
    }
}

export default Header_for_multistep;